<template>
    <table
        class="numpad-table"
        :class="{ dark: dark }"
    >
        <tr>
            <td>
                <v-btn
                    ref="btn7"
                    class="numpad-button"
                    :class="{ disabled: disabled }"
                    :disabled="disabled"
                    depressed
                    @click="input('7')"
                >
                    7
                </v-btn>
            </td>
            <td>
                <v-btn
                    ref="btn8"
                    class="numpad-button"
                    :class="{ disabled: disabled }"
                    :disabled="disabled"
                    depressed
                    @click="input('8')"
                >
                    8
                </v-btn>
            </td>
            <td>
                <v-btn
                    ref="btn9"
                    class="numpad-button"
                    :class="{ disabled: disabled }"
                    :disabled="disabled"
                    depressed
                    @click="input('9')"
                >
                    9
                </v-btn>
            </td>
            <td>
                <v-btn
                    ref="btnClear"
                    class="numpad-button action"
                    :class="{ disabled: disabled }"
                    :disabled="disabled"
                    depressed
                    @click="clear"
                >
                    C
                </v-btn>
            </td>
        </tr>
        <tr>
            <td>
                <v-btn
                    ref="btn4"
                    class="numpad-button"
                    :class="{ disabled: disabled }"
                    :disabled="disabled"
                    depressed
                    @click="input('4')"
                >
                    4
                </v-btn>
            </td>
            <td>
                <v-btn
                    ref="btn5"
                    class="numpad-button"
                    :class="{ disabled: disabled }"
                    :disabled="disabled"
                    depressed
                    @click="input('5')"
                >
                    5
                </v-btn>
            </td>
            <td>
                <v-btn
                    ref="btn6"
                    class="numpad-button"
                    :class="{ disabled: disabled }"
                    :disabled="disabled"
                    depressed
                    @click="input('6')"
                >
                    6
                </v-btn>
            </td>
            <td class="bordered">
                <v-btn
                    ref="btnBackspace"
                    class="numpad-button action"
                    :class="{ disabled: disabled }"
                    :disabled="disabled"
                    depressed
                    @click="backspace"
                >
                    <v-icon>fal fa-backspace</v-icon>
                </v-btn>
            </td>
        </tr>
        <tr>
            <td>
                <v-btn
                    ref="btn1"
                    class="numpad-button"
                    :class="{ disabled: disabled }"
                    :disabled="disabled"
                    depressed
                    @click="input('1')"
                >
                    1
                </v-btn>
            </td>
            <td>
                <v-btn
                    ref="btn2"
                    class="numpad-button"
                    :class="{ disabled: disabled }"
                    :disabled="disabled"
                    depressed
                    @click="input('2')"
                >
                    2
                </v-btn>
            </td>
            <td>
                <v-btn
                    ref="btn3"
                    class="numpad-button"
                    :class="{ disabled: disabled }"
                    :disabled="disabled"
                    depressed
                    @click="input('3')"
                >
                    3
                </v-btn>
            </td>
            <td class="bordered" rowspan="2">
                <v-btn
                    ref="btnConfirm"
                    class="numpad-button action"
                    color="#e6a23b"
                    :class="{ disabled: !okButtonEnabled || disabled }"
                    :disabled="!okButtonEnabled || disabled"
                    depressed
                    @click="confirm"
                >
                    {{ $t('general.ok') }}
                </v-btn>
            </td>
        </tr>
        <tr>
            <td>
                <v-btn
                    v-if="!signButtonReplace"
                    ref="btnSign"
                    class="numpad-button"
                    :class="{ disabled: !signButtonEnabled || disabled }"
                    :disabled="!signButtonEnabled || disabled"
                    depressed
                    @click="sign"
                >
                    +/-
                </v-btn>

                <v-btn
                    v-else
                    ref="btnMultiply"
                    class="numpad-button"
                    :class="{ disabled: disabled }"
                    :disabled="disabled"
                    depressed
                    @click="input(signButtonReplace)"
                >
                    {{ signButtonReplace }}
                </v-btn>
            </td>
            <td>
                <v-btn
                    ref="btn0"
                    class="numpad-button"
                    :class="{ disabled: disabled }"
                    :disabled="disabled"
                    depressed
                    @click="input('0')"
                >
                    0
                </v-btn>
            </td>
            <td>
                <v-btn
                    ref="btnDecimalPoint"
                    class="numpad-button"
                    :class="{ disabled: disabled }"
                    :disabled="disabled"
                    depressed
                    @click="decimalPoint"
                >
                    .
                </v-btn>
            </td>
        </tr>
    </table>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: '0'
        },
        okButtonEnabled: {
            type: Boolean,
            default: true
        },
        signButtonEnabled: {
            type: Boolean,
            default: true
        },
        signButtonReplace: {
            type: String,
            default: null
        },
        precision: {
            type: Number,
            default: 2
        },
        max: {
            type: [Number, String],
            default: null
        },
        resetPending: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        dark: {
            type: Boolean,
            default: true
        }
    },

    created() {
        document.addEventListener('keydown', this.keyDownHandler);

        if (this.value === null) {
            this.$emit('input', '0');
        }
    },

    beforeDestroy() {
        document.removeEventListener('keydown', this.keyDownHandler);
    },

    data: () => ({
        internalValue: '0'
    }),

    watch: {
        value(val) {
            if (val === null) {
                this.$emit('input', '0');
                return;
            }

            this.internalValue = val;
        }
    },

    methods: {
        backspace() {
            if (this.resetPending) {
                this.clear();
            }

            let newVal = this.internalValue.substring(0, this.internalValue.length - 1);
            if (newVal[newVal.length - 1] === '.') {
                newVal = newVal.substring(0, newVal.length - 1);
            }

            this.internalValue = newVal.length > 0 && newVal != '-' ? newVal : '0';
            this.$emit('input', this.internalValue);
        },

        clear() {
            this.internalValue = '0';
            this.$emit('input', this.internalValue);
            if (this.resetPending) {
                this.$emit('update:resetPending', false);
            }
        },

        sign() {
            if (this.resetPending) {
                this.clear();
            }

            this.internalValue =
                this.internalValue[0] === '-'
                    ? this.internalValue.substring(1, this.internalValue.length)
                    : '-' + this.internalValue;
            this.$emit('input', this.internalValue);
        },

        decimalPoint() {
            if (this.resetPending) {
                this.clear();
            }

            if (!this.internalValue.includes('.')) {
                this.internalValue += '.';
            }

            this.$emit('input', this.internalValue);
        },

        input(key) {
            if (this.resetPending) {
                this.clear();
            }

            if(this.internalValue.includes('*') && key === '*') return;
            if(this.internalValue.includes('*') && this.internalValue.split('*')[1].length > 14) return;

            if(key === '*' || this.internalValue.includes('*')) {
                this.internalValue += key;
                this.$emit('input', this.internalValue);
                return;
            }

            if (this.internalValue.length > 14) {
                return;
            }

            if (this.internalValue.includes('.') && this.internalValue.split('.')[1].length >= this.precision) {
                return;
            }

            let newVal = null;
            if (this.internalValue == '0') {
                newVal = key;
            } else if (this.internalValue == '-0') {
                newVal = '-' + key;
            } else {
                newVal = this.internalValue + key;
            }

            if (this.max !== null && Math.abs(newVal) > parseFloat(this.max)) {
                return;
            }

            this.internalValue = newVal;
            this.$emit('input', this.internalValue);
        },

        confirm() {
            this.$emit('confirm', parseFloat(this.internalValue));
        },

        click(button) {
            const btn = this.$refs[button]
            if(!btn || btn.disabled) return
            btn.$refs.link.click()
        },

        keyDownHandler(event) {
            event.stopPropagation();
            event.preventDefault();

            var keyCode = event.keyCode || event.which;

            // Backspace
            if(keyCode == 8) {
                this.click('btnBackspace')
                return
            }

            // Enter
            if(keyCode == 13) {
                this.click('btnConfirm')
                return
            }

            // Minus
            if(keyCode == 189) {
                this.click('btnSign')
                return
            }

            // Multiply
            if((keyCode == 56 && event.shiftKey) || keyCode == 106) {
                this.click('btnMultiply')
                return
            }

            // Period / Comma
            if(keyCode == 190 || keyCode == 188 || keyCode == 110) {
                this.click('btnDecimalPoint')
                return
            }

            // Escape
            if(keyCode == 27) {
                this.click('btnClear')
                return
            }

            // Digits
            if (keyCode >= 48 && keyCode <= 57) {
                keyCode -= 48;
                this.click('btn' + keyCode)
                return
            }

            // Digits Numpad
            if (keyCode >= 96 && keyCode <= 105) {
                keyCode -= 96;
                this.click('btn' + keyCode)
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.numpad-table {
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;
    background: white;

    td {
        height: 75px;
        width: 25%;

        &.bordered {
            border-top: 1px solid #f0b762;
        }

        ::v-deep .numpad-button {
            padding: 0;
            margin: 0;
            border-radius: 0;
            height: 100%;
            width: 100%;
            min-width: 0;
            font-size: 20px;
            color: #3f4456;
            background-color: #ececec !important;

            &.v-btn.v-btn--disabled.disabled {
                background-color: #ececec !important;
            }

            &.action {
                background-color: #efc88e !important;

                &.v-btn--disabled.disabled {
                    background-color: #efc88e !important;
                    color: #c5ad88 !important;

                    .v-icon {
                        color: #d29232 !important;
                    }
                }
            }
        }
    }

    &.dark {
        td {
            &.bordered {
                border-top: 1px solid #b97611;
            }

            ::v-deep .numpad-button {
                color: white;
                background-color: #3f4456 !important;

                &.v-btn.v-btn--disabled.disabled {
                    background-color: #3f4456 !important;
                }

                &.action {
                    background-color: #e6a23b !important;

                    &.v-btn--disabled.disabled {
                        background-color: #e6a23b !important;
                        color: #dab787 !important;

                        .v-icon {
                            color: #dab787 !important;
                        }
                    }
                }
            }
        }
    }
}
</style>
